import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Autoplay, Pagination, FreeMode } from 'swiper';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import classes from './BrandsSlider.module.scss';

SwiperCore.use([Autoplay]);

const brands = [
    'Roche', 'Takeda', 'Sanofi', 'GSK', 'Boehringer Ingelheim',
    'Abbott', 'Johnson & Johnson', 'Cipla', 'Hikma Pharmaceuticals',
    'Octapharma', 'Springer Nature', 'Grifols', 'STADA', 'Biocon', 'Eva Pharma',
];

export default function BrandsSlider() {
    const items = [...brands, ...brands, ...brands]; // duplicate for seamless flow

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-12'>
                    <div className={classes['brands-slider']} style={{ overflow: 'hidden', maxWidth: '100%' }}>
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={32}
                            slidesPerView={'auto'}
                            loop={true}
                            loopedSlides={brands.length}
                            speed={3000} // increase/decrease to control scroll speed
                            autoplay={{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false }}
                            allowTouchMove={false}
                        >
                            {items.map((name, i) => (
                                <SwiperSlide key={i} style={{ width: 'auto' }}>
                                    <div className={classes['brand-item']} >
                                        {name}
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>

    );
}